import { useTranslation } from 'react-i18next';
import { type Translations } from '@domain/admission';
import { type AdmissionGroupItem } from '@domain/admission-group';
import { useEventMutation } from '@hooks/use-event-mutation';
import { useToast } from '@hooks/use-toast/use-toast';
import { useEventUIStore } from '@stores/event-ui-store';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants';

export interface GroupCreateRequest {
  name: Translations;
}

export interface GroupCreateResponse {
  id: string;
  name: Translations;
  displayName: string;
  items: AdmissionGroupItem[];
}

const createGroupFetch = async (sectionId: string, group: GroupCreateRequest) => {
  const url = `${import.meta.env.VITE_OFFERS_HOST}/v1/nightgraph/sections/${sectionId}/offer-groups`;

  return request({
    url,
    method: RequestMethod.POST,
    body: group,
  });
};

export const useCreateGroup = ({ eventId }: { eventId?: string } = {}) => {
  const { t } = useTranslation();
  const toast = useToast();
  return useEventMutation<GroupCreateResponse, RequestError, { sectionId: string; group: GroupCreateRequest }>(
    [QUERY_KEYS.createGroup],
    async ({ sectionId, group }) => createGroupFetch(sectionId, group),
    {
      eventId,
      onSuccess: (data: GroupCreateResponse) => {
        useEventUIStore.getState().setForceOpenGroupId(data.id);
        useEventUIStore.getState().setScrollTargetId(data.id);

        toast.push({
          title: t('admissionGroups:createGroupSuccessMessage', { groupName: data.displayName }),
          text: '',
          type: 'success',
        });
      },
    }
  );
};
